<mydocma-app-pane-header [text]="('MM.structure.title' | translate)"
                         [doneVisible]="false"
                         iconName="account_tree"
                         (closeClick)="onCloseClick()"
                         [closeVisible]="!(appContainerService.mobileView$ | async)">
</mydocma-app-pane-header>
<div style="position: relative; height: 100%;">
  <mydocma-loader *ngIf="loading$ | async" [size]="'small'" class="mydocma-mm-loader"></mydocma-loader>
  <mydocma-mm-structure-tree #structureTree class="left-pane-structure-tree" [structures]="strcutures$ | async"
                             (structureClick)="onStructureClick($event)"></mydocma-mm-structure-tree>
</div>
<div class="mobile-pane-footer" *ngIf="(appContainerService.mobileView$ | async)">
  <div style="margin-right: 10px">
    <button mat-stroked-button (click)="onCloseClick()" class="mydocma-btn-primary">
      {{'Ok'}}
    </button>
  </div>
</div>

